<template>
  <router-link :to="{...$local('Project'), params: {slug: data.slug}}">
    <div class="u-radius u-overflow-hidden u-bg-white" :class="isSmall || $device.isMobile ? 'u-box-16by9' : 'u-box-4by16'">
      <app-image :width="imgWidth" :height="imgHeight" format="webp" :quality="80" class="u-fit-cover u-wrapper-panel" v-if="data.brightPreview.length" :id="data.brightPreview[0].id" :src="data.brightPreview[0].url"/>
    </div>
    <div class="u-row u-top" :class="{'u-pad-x-1of10' : !isSmall && !$device.isMobile}">
      <h4 class="u-uppercase t-text t-bold u-blue" :class="!isSmall && !$device.isMobile ? 'u-w3of10 t-text--big u-marg-t-md' : 'u-w10of10 t-text u-marg-t-sm u-pad-t-sm'">
        {{ data.title }}
      </h4>
      <div class="t-text" :class="!isSmall && !$device.isMobile ? 'u-w6of10 u-marg-l-1of10 u-marg-t-md' : 'u-w10of10 u-marg-t-sm u-pad-t-sm u-pad-r-2of10'">
        {{ data.description }}
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {return {}}
    },
    isSmall: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    imgWidth () {
      if (this.isSmall) {
        return 730 * Math.min(2, window.devicePixelRatio)
      }

      return 1530 * Math.min(2, window.devicePixelRatio)
    },
    imgHeight () {
      if (this.isSmall) {
        return 412 * Math.min(2, window.devicePixelRatio)
      }

      return 380 * Math.min(2, window.devicePixelRatio)
    }
  }
}
</script>